import {
  getDeviceByDsnWeb,
  getDeviceCustomerById,
  getDeviceDataForGsn,
  getCcnGatherListForWeb,
  getGatherInfosForWeb,
  getMonitorHistoryByGsn,
  CreateRealTimeShadow,
  getMonitorRealForWeb,
  getDeviceUseRateList,
  getDeviceLoadedChangeList,
  getMaintainItemConfirmTable,
  getMaintainRecord,
  getLatestMonitorDataProcess,
  getMonitorAlarm,
  getAlarmDetailById,
} from "../api/api";
import { watch } from "vue";
export const monitorMixin = {
  data() {
    return {
      pacCcnFilterArr: [
        "System Pressure",
        "Stage 1 Temperature",
        "Stage 1 Vibration",
        "Stage 1 Pressure",
        "Stage 2 Temperature",
        "Stage 2 Vibration",
        "Stage 2 Pressure",
        "Stage 3 Temperature",
        "Stage 3 Vibration",
        "Stage 3 Pressure",
      ],
      dialogDevice: false,
      deviceTitle: "",
      infoDsn: "",
      isDingOrBian: "ding",
      DeviceInfo: {},
      DeviceInfoShow: {},
      CustomerInfo: {},
      UseRateData: "",
      LoadedChangeData: "",
      isShowChart: true,
      echartID: {},
      echartIDHistory: {},
      stopSetTimeOut: {},
      stopDeviceData: {},
      IsShowSensitive: true,
      unitList: [
        "temperature",
        "pressure",
        "speed",
        "current",
        "voltage",
        "power",
        "frequency",
        "mm/s",
        "bar",
        "℃",
        "micron",
        "Deg C",
        "mbarA",
        "mbarG",
        "kW",
        "Hz",
        "V",
        "A",
        "kPa",
        "%",
        "m³/min",
      ],
      infoDsn: "",

      monitorHistoryData: {},
      realMonitorData: {},

      ccnGatherList: [],
      ccnGatherOption: [],
      gatherOption: [],
      ccnCodeList222: [],

      interfaceTimes: 15,
      isShowErr: true,

      tableTitle: "",
      tableType: "",
      tableCCN: [],
      dialogDeviceCCN: false,

      serviceform: {},
      maintainTitle: "",
      maintainList: [],
      dialogMaintain: false,
      tableService: [],
      TableH: 0,

      //实时监控datazoom起始结束位置
      timeZoomStart: 0,
      timeZoomEnd: 100,
      eightSpanArr: {
        PacMU: [
          "kstate",
          "kTime",
          "loadTime",
          "systemPre",
          "dischargePre",
          "stage1Vir",
          "stage2Intemp",
        ],
        PacNotMU: [
          "kstate",
          "kTime",
          "loadTime",
          "systemPre",
          "stage1Pre",
          "stage1Vir",
          "stage1Temp",
        ],
        ding: ["kstate", "kTime", "loadTime", "dp", "sdt2", "rp", "mc"],
        bian: ["kstate", "kTime", "vms", "dp", "sdt2", "targetP", "mc"],
        BS5DH: ["kstate", "kTime", "vms", "dp", "sdt2", "targetP", "mc"],
        SVT: ["kstate", "kTime", "vms", "dp", "sdt2", "targetP", "mc"],
        BM200: ["kstate", "kTime", "vms", "dp", "sdt2", "targetP", "mc"],
      },
      toolParam: {},
      toolNumber: 0,
    };
  },
  watch: {
    toolNumber: {
      handler(newValue, oldValue) {
        this.toolClick();
      },
    },
  },
  created() {
    //this.getGatherOption();
  },
  methods: {
    //监控列表页面打开弹窗
    openMonitorListDevice(visible, item) {
      this.dialogDevice = visible;
      if (visible) {
        this.infoDsn = item.dsn;
        this.deviceTitle = this.$t("desc.airCompressorSN") + "：" + item.dsn;
        this.DeviceInfo = item;
        this.getGatherOption(item.productLineType);
        this.DeviceInfoShow = JSON.parse(JSON.stringify(this.DeviceInfo));
        this.getCcnGatherList(item.ccn, item.ccnVersion, item);
        if (item.productLineType == "PAC") {
          if (item.ccnModel == "MU") {
            this.isDingOrBian = "PacMU";
          } else {
            this.isDingOrBian = "PacNotMU";
          }
        } else if (item.productLineType == "BV") {
          if (
            item.kSmall.indexOf("BS") > -1 ||
            item.kProduct.indexOf("BS") > -1 ||
            item.kPower.indexOf("BS") > -1
          ) {
            this.isDingOrBian = "BS5DH";
          } else if (
            item.kSmall.indexOf("SVT") > -1 ||
            item.kProduct.indexOf("SVT") > -1 ||
            item.kPower.indexOf("SVT") > -1
          ) {
            this.isDingOrBian = "SVT";
          } else if (
            item.kSmall.indexOf("IDP") > -1 ||
            item.kProduct.indexOf("IDP") > -1 ||
            item.kPower.indexOf("IDP") > -1
          ) {
            this.isDingOrBian = "IDP";
          } else if (
            item.kSmall.indexOf("MC") > -1 ||
            item.kProduct.indexOf("MC") > -1 ||
            item.kPower.indexOf("MC") > -1
          ) {
            this.isDingOrBian = "MC";
          }else {
            this.isDingOrBian = "BM200";
          }
        } else if (item.kProduct) {
          if (
            item.kProduct.indexOf("VSD") != -1 ||
            item.kProduct.indexOf("变频") != -1
          ) {
            this.isDingOrBian = "bian";
          } else {
            this.isDingOrBian = "ding";
          }
        }
        this.getDeviceUseRateList(item.dsn, item.gsn);
        this.getDeviceLoadedChangeList(item.dsn, item.gsn);
        this.getMaintainRecord(item.dsn);
        //打开空压机详细窗口时获取实时监控数据
      } else {
        this.DeviceInfo = {};
        this.DeviceInfoShow = {};
        this.ccnCodeList222 = new Array();
        if (this.echartID.id) {
          this.echartID.hideLoading();
          this.echartID.clear();
        }
        if (this.echartIDHistory.id) {
          this.echartIDHistory.hideLoading();
          this.echartIDHistory.clear();
        }
        //停止当前settimeout 实时监控
        if (this.stopSetTimeOut) {
          clearTimeout(this.stopSetTimeOut);
        }
      }
    },
    //告警页面打开弹窗
    async getDeviceByDsn(dsn, gsn) {
      let that = this;
      that.DeviceInfoShow = {};
      this.dialogDevice = true;
      this.deviceTitle = this.$t("desc.airCompressorSN") + "：" + dsn;
      //device详细
      let res = await getDeviceByDsnWeb(dsn, gsn);
      //八块数据 要在获取device详细之后运行
      await that.openDevice(true, res.result);
    },
    //设备相关页面打开弹窗
    async openDevice(visible, item) {
      this.dialogDevice = visible;
      if (visible) {
        this.deviceTitle = this.$t("desc.airCompressorSN") + "：" + item.dsn;
        this.DeviceInfo = item;
        this.DeviceInfoShow = JSON.parse(JSON.stringify(this.DeviceInfo));
        console.log('this.DeviceInfoShow', this.DeviceInfoShow);
        if (item.productLineType == "PAC") {
          if (item.ccnModel == "MU") {
            this.isDingOrBian = "PacMU";
          } else {
            this.isDingOrBian = "PacNotMU";
          }
        } else if (item.productLineType == "BV") {
          if (
            item.kSmall.indexOf("BS") > -1 ||
            item.kProduct.indexOf("BS") > -1 ||
            item.kPower.indexOf("BS") > -1
          ) {
            this.isDingOrBian = "BS5DH";
          } else if (
            item.kSmall.indexOf("SVT") > -1 ||
            item.kProduct.indexOf("SVT") > -1 ||
            item.kPower.indexOf("SVT") > -1
          ) {
            this.isDingOrBian = "SVT";
          } else if (
            item.kSmall.indexOf("IDP") > -1 ||
            item.kProduct.indexOf("IDP") > -1 ||
            item.kPower.indexOf("IDP") > -1
          ) {
            this.isDingOrBian = "IDP";
          } else if (
            item.kSmall.indexOf("MC") > -1 ||
            item.kProduct.indexOf("MC") > -1 ||
            item.kPower.indexOf("MC") > -1
          ) {
            this.isDingOrBian = "MC";
          } else {
            this.isDingOrBian = "BM200";
          }
        } else if (item.kProduct) {
          if (
            item.kProduct.indexOf("VSD") != -1 ||
            item.kProduct.indexOf("变频") != -1
          ) {
            this.isDingOrBian = "bian";
          } else {
            this.isDingOrBian = "ding";
          }
        }
        //打开空压机详细窗口时获取实时监控数据
        var codeList = new Array();
        this.getDeviceCustomerById(item.customerId);
        this.getDeviceData(item.gsn, item.ccn, item.ccnVersion, item);
        this.getGatherOption(item.productLineType);
        this.getMaintainRecord(item.dsn);
        await this.getDeviceUseRateList(item.dsn, item.gsn);
        await this.getDeviceLoadedChangeList(item.dsn, item.gsn);
      } else {
        this.DeviceInfo = {};
        this.DeviceInfoShow = {};
        this.CustomerInfo = {};
        this.UseRateData = {};
        this.LoadedChangeData = {};
        this.ccnCodeList222 = new Array();
        this.isShowChart = true;
        //初始利用率表格
        let data = {
          dayTimeList: new Array(),
          dayDataList: new Array(),
        };
        this.InitURateLine(data);
        let loadedData = {
          dayTimeList: new Array(),
          dayDataList: new Array(),
        };
        this.InitLoadedChangeLine(loadedData);
        if (this.echartID.id) {
          this.echartID.hideLoading();
          this.echartID.clear();
        }
        if (this.echartIDHistory.id) {
          this.echartIDHistory.hideLoading();
          this.echartIDHistory.clear();
        }
        //停止当前settimeout 实时监控
        if (this.stopSetTimeOut) {
          window.clearTimeout(this.stopSetTimeOut);
        }
        if (this.stopDeviceData) {
          window.clearTimeout(this.stopDeviceData);
        }
      }
    },
    async getCcnGatherList(ccn, version, item) {
      let that = this;
      this.isShowChart = false;
      let res = await getCcnGatherListForWeb(ccn, version);
      let data = res.result;
      let ccnCodeList = new Array();
      let ccnCodeList2 = new Array();
      for (let index = 0; index < data.ccnGathers.length; index++) {
        ccnCodeList.push(data.ccnGathers[index].gatherId);
        ccnCodeList2.push(data.ccnGathers[index].gatherName);
      }
      that.ccnGatherList = ccnCodeList2;
      let gatherType = "Other";
      if (
        that.DeviceInfo.kType == "离心机" ||
        that.DeviceInfo.kType == "Centrifuge"
      ) {
        gatherType = "PAC";
      }
      that.ccnGatherOption = that.gatherOption.filter(
        (bbb) =>
          ccnCodeList.some((code) => code == bbb.id) &&
          this.unitList.some((unit) => unit == bbb.unit) &&
          bbb.gatherType.toLowerCase() == item.productLineType.toLowerCase()
      );
      var codeList = new Array();
      this.$nextTick(() => {
        if (
          this.ccnGatherOption.some(
            (aaa) => aaa.name == "Compressor Discharge Temperature"
          )
        ) {
          codeList.push("Compressor Discharge Temperature");
          this.ccnCodeList222.push("Compressor Discharge Temperature");
        }
        if (
          this.ccnGatherOption.some(
            (aaa) => aaa.name == "Final Stage Discharge Temperature"
          )
        ) {
          codeList.push("Final Stage Discharge Temperature");
          this.ccnCodeList222.push("Final Stage Discharge Temperature");
        }
        if (
          this.ccnGatherOption.some(
            (aaa) => aaa.name == "Compressor Discharge Pressure"
          )
        ) {
          codeList.push("Compressor Discharge Pressure");
          this.ccnCodeList222.push("Compressor Discharge Pressure");
        }
        if (item.productLineType == "PAC") {
          if (
            this.ccnGatherOption.some((aaa) => aaa.name == "System Pressure")
          ) {
            codeList.push("System Pressure");
            this.ccnCodeList222.push("System Pressure");
          }
        }
        if (item.productLineType == "BV") {
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Airend Discharge Pressure"
            )
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Airend Discharge Pressure"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Airend Discharge Temperature"
            )
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Airend Discharge Temperature"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Blower Inlet Pressure"
            ) &&
            item.kPower == "BM200"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Blower Inlet Pressure"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Blower Inlet Temperature"
            ) &&
            item.kPower == "BM200"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Blower Inlet Temperature"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }

          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Vacuum Pump Discharge Pressure"
            ) &&
            item.kSmall == "IDP"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Vacuum Pump Discharge Pressure"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "Vacuum Pump Discharge Temperature"
            ) &&
            item.kSmall == "IDP"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "Vacuum Pump Discharge Temperature"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          // if (
          //   this.ccnGatherOption.some(
          //     (a) => a.name == "Vacuum Pump Inlet Temperature"
          //   ) &&
          //   item.kSmall == "IDP"
          // ) {
          //   let code = this.ccnGatherOption.find(
          //     (a) => a.name == "Vacuum Pump Inlet Temperature"
          //   );
          //   codeList.push(code.name);
          //   this.ccnCodeList222.push(code.name);
          // }
          
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "P_Package Discharge"
            ) &&
            item.kSmall == "MC"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "P_Package Discharge"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "T_S4 Discharge"
            ) &&
            item.kSmall == "MC"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "T_S4 Discharge"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "T_Ambient"
            ) &&
            item.kSmall == "MC"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "T_Ambient"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "MM1_Speed"
            ) &&
            item.kSmall == "MC"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "MM1_Speed"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
          if (
            this.ccnGatherOption.some(
              (a) => a.name == "MM2_Speed"
            ) &&
            item.kSmall == "MC"
          ) {
            let code = this.ccnGatherOption.find(
              (a) => a.name == "MM2_Speed"
            );
            codeList.push(code.name);
            this.ccnCodeList222.push(code.name);
          }
        }
      });
    },
    async getDeviceCustomerById(custId) {
      let that = this;
      let postData = { id: custId };
      let res = await getDeviceCustomerById(postData);
      let data = res.result;
      that.CustomerInfo = data;
    },
    async getGatherOption(gatherType) {
      let that = this;      
      let res = await getGatherInfosForWeb(gatherType);
      let data = res.result;
      that.gatherOption = data;
    },
    async getMonitorHistoryByGsn(codeList, gsn, date) {
      let that = this;
      let postData = {
        gsn: gsn,
        date: date,
      };
      let kchart = this.$echarts.init(document.getElementById("KchartTime2"));
      this.echartIDHistory = kchart;
      //展示echart loading
      kchart.showLoading({
        text: "loading",
        color: "#3A6BB5",
        textColor: "#000",
        maskColor: "#242731",
      });
      try {
        let res = await getMonitorHistoryByGsn(postData);

        let data = res.result;
        if (!data || data.length === 0) {
          kchart.hideLoading();
          this.echartIDHistory.clear();
          return false;
        }
        // 监控告警部分
        let start = date[0];
        let end = date[1];
        if (typeof date[0] !== "string") {
          start = date[0].format("yyyy-MM-dd");
          end = date[1].format("yyyy-MM-dd");
        }
        let postData2 = {
          gsn: gsn,
          start: start,
          end: end,
        };
        let alarmRes = await getMonitorAlarm(postData2);
        //处理告警数据和x坐标的关系
        let monitorAlarmArr = new Array();
        if (alarmRes.result && alarmRes.result.length > 0) {
          for (let index = 0; index < data.dateTimeList.length; index++) {
            const element = data.dateTimeList[index];
            let curAlarm = 0;
            if (index == 0) {
              curAlarm = alarmRes.result.find((a) => a.alarmTime == element);
            } else {
              curAlarm = alarmRes.result.find(
                (a) =>
                  a.alarmTime <= element &&
                  a.alarmTime >= data.dateTimeList[index - 1]
              );
            }
            if (!curAlarm) {
              curAlarm = 0;
            }
            monitorAlarmArr.push(curAlarm);
          }
        }

        let totalData = {};
        totalData.chartDataList = new Array();
        totalData.codeList = new Array();
        totalData = data;
        let selDataList = data.chartDataList.filter((item) =>
          codeList.some((aaa) => aaa === item.code)
        );

        totalData.chartDataList = selDataList;

        totalData.codeList = data.codeList.filter((item) =>
          codeList.some((aaa) => aaa === item)
        );
        //隐藏echart loading
        this.$nextTick(() => {
          setTimeout(() => {
            kchart.hideLoading();
            that.initEchartsGsntemp(kchart, totalData, monitorAlarmArr);
          }, 300);
        });
      } catch (error) {
        kchart.hideLoading();
      }
    },
    async getRealData(minute, codeList, gsn, pressTimes) {
      let that = this;
      if (this.stopSetTimeOut) {
        clearTimeout(this.stopSetTimeOut);
      }
      let postData = {
        gsn: gsn,
        minutes: minute,
        frequency: 1,
      };
      //记录发送命令的时间
      var myData = new Date();
      that.isShowErr = false;
      this.interfaceTimes = 15;
      let res = await CreateRealTimeShadow(postData);
      let data = res.result;
      if (data) {
        this.echartID = this.$echarts.init(
          document.getElementById("KchartTime")
        );
        //展示echart loading
        this.echartID.showLoading({
          text: "loading",
          color: "#3A6BB5",
          textColor: "#000",
          maskColor: "#242731",
        });
        //循环调取
        this.stopSetTimeOut = window.setTimeout(() => {
          that.getMonitorReal(myData, that.ccnCodeList, gsn, pressTimes);
        }, 3000);
      }
    },
    async getMonitorReal(startTime, codeList, gsn, pressTimes) {
      let that = this;
      if (pressTimes != this.$refs.deviceInfoRef.pressTimes) {
        return false;
      }
      let data = {
        gsn: gsn,
        startTime: startTime,
        language: this.activeLang,
      };
      let res = await getMonitorRealForWeb(data);
      try {
        let data = res.result;
        if (!data && that.isShowErr) {
          return false;
        }
        //关掉窗口时 跳出循环
        if (!this.dialogDevice) {
          return false;
        }

        let json = JSON.stringify(data);
        that.realMonitorData = JSON.parse(json);
        if (that.realMonitorData && that.realMonitorData.chartDataList) {
          // let json = JSON.stringify(data);
          that.isShowErr = true;
          // that.realMonitorData = JSON.parse(json);
          let totalData = {};
          totalData.chartDataList = new Array();
          totalData.codeList = new Array();
          totalData = data;
          let selDataList = data.chartDataList.filter((item) =>
            codeList.some((aaa) => aaa === item.code)
          );

          totalData.chartDataList = selDataList;

          totalData.codeList = data.codeList.filter((item) =>
            codeList.some((aaa) => aaa === item)
          );
          //隐藏echart loading
          that.echartID.hideLoading();
          that.initTimeEcharts(totalData);
        } else {
          //未获取到数据
          this.interfaceTimes--;
        }
        if (this.interfaceTimes < 0) {
          that.$message({
            showClose: true,
            message: "加载失败！",
            type: "error",
          });
          this.echartID.hideLoading();
        } else {
          let _this = this;
          //现在是没获取到数据会一直调用接口 从获取到数据到获取不到数据是才停止
          this.stopSetTimeOut = setTimeout(function () {
            _this.getMonitorReal(startTime, _this.ccnCodeList, gsn, pressTimes);
          }, 3 * 1000);
        }
      } catch (err) {
        that.$message({
          showClose: true,
          message: "加载失败！",
          type: "error",
        });
        this.echartID.hideLoading();
      }
    },
    openCcnTable(visible, gsn, type) {
      this.dialogDeviceCCN = visible;
      if (visible) {
        this.tableTitle = this.$t("title.monitorDataDetail");
        if (type == "ccn") {
          this.tableTitle = this.$t("title.ccnDataDetail");
          this.tableType = "ccn";
          this.getCcnTable(gsn);
        } else if (type == "monitor") {
          this.tableType = "monitor";
          this.getMonitorTable(gsn);
        }
      } else {
        this.tableCCN = new Array();
      }
    },
    async getMonitorTable(gsn) {
      let that = this;
      let postData = {
        gsn: gsn,
      };
      let res = await getLatestMonitorDataProcess(postData);
      let curData = res.result;
      if (
        this.DeviceInfo.kType == "离心机" ||
        this.DeviceInfo.kType == "Centrifuge"
      ) {
        curData.data = curData.data.filter((x) =>
          that.pacCcnFilterArr.some((y) => y == x.n)
        );
      }
      if (!curData) return false;
      for (let index = 0; index < curData.data.length; index++) {
        let ccnData = {
          expand: false,
          name: "",
          value: "",
          unit: "",
          time: "",
          stateList: [],
        };
        //状态字跳过
        if (curData.data[index].n !== "StatusWordDesc") {
          if (this.activeLang == "zh") {
            // ccnData.name = that.gatherOption.find(
            //   (item) => item.name === curData.data[index].n
            // )?.nameZH;
            ccnData.name = curData.data[index].z;
          } else {
            ccnData.name = curData.data[index].n;
          }
          // ccnData.name = curData.data[index].n;
          ccnData.value = curData.data[index].v;
          ccnData.unit =
            curData.data[index].unit == "小时"
              ? "" //this.$t("desc.hours")
              : curData.data[index].unit;
          ccnData.time = curData.date.replace("T", " ").replace("Z", "");
          //添加状态字解析
          if (curData.data[index].n === "Compressor Status Word" || curData.data[index].n === "Package Status") {
            ccnData.expand = true;
            let statusWordDesc = curData.data.find(
              (item) => item.n === "StatusWordDesc"
            );
            if (statusWordDesc) {
              let stateArr = JSON.parse(statusWordDesc.v);
              ccnData.stateList = stateArr;
            }
          }
          that.tableCCN.push(ccnData);
        }
      }
      that.tableCCN = that.tableCCN.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    getCcnTable(gsn) {
      let that = this;
      if (this.monitorHistoryData) {
        var curData = JSON.parse(JSON.stringify(this.monitorHistoryData));
        if (Array.isArray(this.monitorHistoryData)) {
          curData = this.monitorHistoryData.find((item) => item.gsn == gsn);
          if (curData.length == 0) return false;
        }
        //先按ccnGather过滤一遍 如果还是两个都有 取其中一个
        curData.data = curData.data.filter(
          (a) =>
            that.ccnGatherList.some((b) => a.n == b) || a.n === "StatusWordDesc"
        );

        for (let index = 0; index < curData.data.length; index++) {
          var ccnData = {
            expand: false,
            name: "",
            value: "",
            unit: "",
            time: "",
            stateList: [],
          };
          //这里判断是基于两个中只会有一个数据的v有值
          if (
            curData.data[index].n === "Final Stage Discharge Temperature" &&
            !curData.data[index].v
          ) {
            continue;
          } else if (
            curData.data[index].n === "2nd Stage Discharge Temperature" &&
            !curData.data[index].v
          ) {
            continue;
          }

          if (
            curData.data[index].n === "Main Motor Current Phase A" &&
            !curData.data[index].v
          ) {
            continue;
          } else if (
            curData.data[index].n === "Driver Motor Current" &&
            !curData.data[index].v
          ) {
            continue;
          }

          //状态字跳过
          if (curData.data[index].n !== "StatusWordDesc") {
            if (this.activeLang == "zh") {
              // ccnData.name = that.gatherOption.find(
              //   (item) => item.name === curData.data[index].n
              // )?.nameZH;              
              ccnData.name = curData.data[index].z;
            } else {
              ccnData.name = curData.data[index].n;
            }
            // ccnData.name = curData.data[index].n;
            ccnData.value = curData.data[index].v;
            ccnData.unit =
              curData.data[index].unit == "小时"
                ? ""
                : curData.data[index].unit;
            ccnData.time = curData.date.replace("T", " ").replace("Z", "");
            //添加状态字解析
            if (curData.data[index].n === "Compressor Status Word") {
              ccnData.expand = true;
              let statusWordDesc = curData.data.find(
                (item) => item.n === "StatusWordDesc"
              );
              if (statusWordDesc) {
                let stateArr = JSON.parse(statusWordDesc.v);
                ccnData.stateList = stateArr;
              }
            }
            that.tableCCN.push(ccnData);
          }
        }
        // that.tableCCN = that.tableCCN.sort((a, b) =>
        //   a.name.localeCompare(b.name)
        // );
      }
    },
    changeCode(codeList) {
      let that = this;
      that.ccnCodeList = codeList;
    },
    async getDeviceUseRateList(dsn, gsn) {
      let that = this;
      let res = await getDeviceUseRateList(dsn, gsn);
      that.UseRateData = res.result;
      this.$nextTick(() => {
        this.InitURateLine(that.UseRateData);
      });
    },
    async getDeviceLoadedChangeList(dsn, gsn) {
      let that = this;
      let res = await getDeviceLoadedChangeList(dsn, gsn);
      that.LoadedChangeData = res.result;
      this.$nextTick(() => {
        this.InitLoadedChangeLine(that.LoadedChangeData);
      });
    },
    async getDeviceData(gsn, ccn, ccnVersion, itemData) {
      let that = this;
      let postdata = {
        gsn: gsn,
      };
      let res = await getDeviceDataForGsn(postdata);
      let data = res.result;
      this.monitorHistoryData = data;
      this.deviceTableShow = new Array();

      var curData = data;
      let nameArrBS5DH = [
        "Package Discharge Pressure",
        "Running Time",
        "Loaded Time",
        "Airend Discharge Pressure",
        "Rated Pressure",
        "Airend Discharge Temperature",
        "Compression Ratio",
      ];
      let nameArrBM200 = [
        //"Package Status",        
        "StatusWordDesc",
        "Blower Inlet Pressure",
        "Blower Inlet Temperature",
        "Package Discharge Pressure",
        "Main Motor Winding Temperature",
        "Current Flow",
        "Main Vsd Motor Speed",
      ];
      let nameArrSVT = [
        "Inlet Pressure",
        "Airend Discharge Pressure",
        "Oil Injection Pressure",
        "Target Pressure",
        "Running Time",
        "Main Vsd Motor Current",
        "Main Vsd Motor Voltage",
      ];
      let nameArrIDP = [
        //"Package Status",
        "StatusWordDesc",
        "Running Time",
        "Loaded Time",
        "Vacuum Pump Inlet Pressure",
        "Target Pressure",
        "Vacuum Pump Case Temperature",
        "Main Vsd Motor Speed",
      ];
      let nameArrMC = [
        "Package Status",
        "P_Package Discharge",
        "Target Pressure",
        "T_S4 Discharge",
        "T_Ambient",
        "MM1_Speed",
        "MM2_Speed",
      ];
      let nArr = new Array();
      let indexName = this.isDingOrBian;
      if (this.isDingOrBian == "BS5DH") {
        nArr = nameArrBS5DH;
      } else if (this.isDingOrBian == "BM200") {
        nArr = nameArrBM200;
      } else if (this.isDingOrBian == "SVT") {
        nArr = nameArrSVT;
      } else if (this.isDingOrBian == "IDP") {
        nArr = nameArrIDP;
      } else if (this.isDingOrBian == "MC") {
        nArr = nameArrMC;
      }
      if (curData) {
        let kstateValue = curData.data.find(
          (a) =>
            a.n == "Compressor Status Word" ||
            a.n.replace(" ", "") == "PackageStatus"
        );
        if (kstateValue && kstateValue.v2) {
          that.DeviceInfo.kstate =
            that.activeLang == "zh"
              ? kstateValue.v2
              : that.$t("desc." + kstateValue.v2.trim());
        } else {
          that.DeviceInfo.kstate = that.$t("tips.NA");
        }
        //pac八块 一级排气压力
        let stage1PreValue = curData.data.find(
          (a) => a.n.replace("  ", " ") == "Stage 1 Pressure"
        );
        if (stage1PreValue && stage1PreValue.v) {
          that.DeviceInfo.stage1Pre =
            stage1PreValue.v + " " + stage1PreValue.unit;
        } else {
          that.DeviceInfo.stage1Pre = that.$t("tips.NA");
        }
        //一级振动
        let stage1VirValue = curData.data.find(
          (a) =>
            a.n.replace("  ", " ") == "Stage 1 Virbation" ||
            a.n.replace("  ", " ") == "Stage 1 Vibration"
        );
        if (stage1VirValue && stage1VirValue.v) {
          that.DeviceInfo.stage1Vir =
            stage1VirValue.v + " " + stage1VirValue.unit;
        } else {
          that.DeviceInfo.stage1Vir = that.$t("tips.NA");
        }
        //一级排气温度
        let stage1TempValue = curData.data.find(
          (a) => a.n.replace("  ", " ") == "Stage 1 Temperature"
        );
        if (stage1TempValue && stage1TempValue.v) {
          that.DeviceInfo.stage1Temp =
            stage1TempValue.v + " " + stage1TempValue.unit;
        } else {
          that.DeviceInfo.stage1Temp = that.$t("tips.NA");
        }
        //系统压力
        let systemPreValue = curData.data.find((a) => a.n == "System Pressure");
        if (systemPreValue && systemPreValue.v) {
          that.DeviceInfo.systemPre =
            systemPreValue.v + " " + systemPreValue.unit;
        } else {
          that.DeviceInfo.systemPre = that.$t("tips.NA");
        }
        //排气压力
        let dischargePreValue = curData.data.find(
          (a) => a.n == "Discharge Pressure"
        );
        if (dischargePreValue && dischargePreValue.v) {
          that.DeviceInfo.dischargePre =
            dischargePreValue.v + " " + dischargePreValue.unit;
        } else {
          that.DeviceInfo.dischargePre = that.$t("tips.NA");
        }
        //二级进气温度
        let stage2IntempValue = curData.data.find(
          (a) => a.n == "Stage 2 Inlet Temp"
        );
        if (stage2IntempValue && stage2IntempValue.v) {
          that.DeviceInfo.stage2Intemp =
            stage2IntempValue.v + " " + stage2IntempValue.unit;
        } else {
          that.DeviceInfo.stage2Intemp = that.$t("tips.NA");
        }

        let targetPValue = curData.data.find((a) => a.n == "Target Pressure");
        if (targetPValue && targetPValue.v) {
          that.DeviceInfo.targetP = targetPValue.v + " " + targetPValue.unit;
        } else {
          that.DeviceInfo.targetP = that.$t("tips.NA");
        }

        let vmsValue = curData.data.find((a) => a.n == "Vsd Motor Speed");
        if (vmsValue && vmsValue.v) {
          that.DeviceInfo.vms = vmsValue.v + " " + vmsValue.unit;
        } else {
          that.DeviceInfo.vms = that.$t("tips.NA");
        }

        let ktimeValue = curData.data.find((a) => a.z == "运行时间");
        if (ktimeValue && ktimeValue.v) {
          if (that.IsShowSensitive == true) {
            that.DeviceInfo.kTime = ktimeValue.v;
          } else {
            that.DeviceInfo.kTime = ktimeValue.v + that.$t("desc.simpleHours");
          }
        } else {
          that.DeviceInfo.kTime = that.$t("tips.NA");
        }

        let dpvalue = curData.data.find(
          (a) => a.n == "Compressor Discharge Pressure"
        );
        if (dpvalue && dpvalue.v) {
          that.DeviceInfo.dp = dpvalue.v + " " + dpvalue.unit;
        } else {
          that.DeviceInfo.dp = that.$t("tips.NA");
        }

        var fsdtValue = curData.data.find(
          (a) => a.n == "Final Stage Discharge Temperature"
        );
        var twosdtValue = curData.data.find(
          (a) => a.n == "2nd Stage Discharge Temperature"
        );
        if (fsdtValue && fsdtValue.v > "0.0") {
          that.DeviceInfo.sdt2 = fsdtValue.v
            ? fsdtValue.v + " " + fsdtValue.unit
            : that.$t("tips.NA");
        } else if (twosdtValue) {
          that.DeviceInfo.sdt2 = twosdtValue.v
            ? twosdtValue.v + " " + twosdtValue.unit
            : that.$t("tips.NA");
        } else if (fsdtValue && fsdtValue.v == "0.0") {
          that.DeviceInfo.sdt2 = fsdtValue.v
            ? fsdtValue.v + " " + fsdtValue.unit
            : that.$t("tips.NA");
        } else {
          that.DeviceInfo.sdt2 = that.$t("tips.NA");
        }

        var rpValue = curData.data.find((a) => a.n == "Rated Pressure");
        if (rpValue && rpValue.v) {
          that.DeviceInfo.rp = rpValue.v + " " + rpValue.unit;
        } else {
          that.DeviceInfo.rp = that.$t("tips.NA");
        }

        var mcValue = curData.data.find((a) => a.n == "Driver Motor Current");
        let mmcpA = curData.data.find(
          (a) => a.n == "Main Motor Current Phase A"
        );
        if (mcValue && mcValue.v > "0.0") {
          that.DeviceInfo.mc = mcValue.v
            ? mcValue.v + " " + mcValue.unit
            : that.$t("tips.NA");
        } else if (mmcpA) {
          that.DeviceInfo.mc = mmcpA.v
            ? mmcpA.v + " " + mmcpA.unit
            : that.$t("tips.NA");
        } else if (mcValue && mcValue.v == "0.0") {
          that.DeviceInfo.mc = mcValue.v
            ? mcValue.v + " " + mcValue.unit
            : that.$t("tips.NA");
        } else {
          that.DeviceInfo.mc = that.$t("tips.NA");
        }

        var loadTimeValue = curData.data.find(
          (a) => a.z == "加载时间" || a.z == "全加载"
        );
        if (loadTimeValue && loadTimeValue.v) {
          if (that.IsShowSensitive == true) {
            that.DeviceInfo.loadTime = loadTimeValue.v;
          } else {
            that.DeviceInfo.loadTime =
              loadTimeValue.v + that.$t("desc.simpleHours");
          }
        } else {
          that.DeviceInfo.loadTime = that.$t("tips.NA");
        }
        //#region BV八块数据
        that.eightSpanArr[indexName] = new Array();
        for (let index = 0; index < nArr.length; index++) {
          const element = nArr[index];
          let BS5DHValue = curData.data.find((a) => a.n == element);
          if (BS5DHValue && BS5DHValue.v) {
            if (element == "Running Time" && that.IsShowSensitive == true) {
              that.DeviceInfo[indexName + index] = BS5DHValue.v;
            } else if (
              element == "Running Time" &&
              that.IsShowSensitive == false
            ) {
              that.DeviceInfo[indexName + index] =
                BS5DHValue.v + that.$t("desc.simpleHours");
            } else {
              that.DeviceInfo[indexName + index] =
                BS5DHValue.v + " " + (BS5DHValue.unit ? BS5DHValue.unit : "");
            }
          } else {
            that.DeviceInfo[indexName + index] = that.$t("tips.NA");
          }
          that.eightSpanArr[indexName].push(indexName + index);
          let translate = that.$t("eightSpan." + indexName + index);
        }
        //#endregion
      } else {
        that.DeviceInfo.kstate = that.$t("tips.NA");
        that.DeviceInfo.kstateNum = that.$t("tips.NA");
        that.DeviceInfo.targetP = that.$t("tips.NA");
        that.DeviceInfo.vms = that.$t("tips.NA");
        that.DeviceInfo.kTime = that.$t("tips.NA");
        that.DeviceInfo.dp = that.$t("tips.NA");
        that.DeviceInfo.dt = that.$t("tips.NA");
        that.DeviceInfo.fsdt = that.$t("tips.NA");
        that.DeviceInfo.sdt2 = that.$t("tips.NA");
        that.DeviceInfo.rp = that.$t("tips.NA");
        that.DeviceInfo.mc = that.$t("tips.NA");
        that.DeviceInfo.loadTime = that.$t("tips.NA");

        that.DeviceInfo.stage1Pre = that.$t("tips.NA");
        that.DeviceInfo.stage1Vir = that.$t("tips.NA");
        that.DeviceInfo.stage1Temp = that.$t("tips.NA");
        that.DeviceInfo.systemPre = that.$t("tips.NA");
        that.DeviceInfo.dischargePre = that.$t("tips.NA");
        that.DeviceInfo.stage2Intemp = that.$t("tips.NA");
        //BV八块数据
        for (let index = 0; index < nArr.length; index++) {
          const element = nArr[index];
          that.DeviceInfo[indexName + index] = that.$t("tips.NA");
        }
        // if (that.DeviceInfo.unLoadTime) that.DeviceInfo.unLoadTime = "";
      }
      //这个方法只能执行一次
      this.$nextTick(() => {
        if (this.isShowChart) {
          this.getCcnGatherList(ccn, ccnVersion, itemData);
        }
      });

      if (this.dialogDevice) {
        this.DeviceInfoShow = new Array();
        this.DeviceInfoShow = JSON.parse(JSON.stringify(this.DeviceInfo));
      }
      this.stopDeviceData = window.setTimeout(function () {
        that.getDeviceData(gsn, ccn, ccnVersion, itemData);
      }, 70 * 1000);
    },

    openMaintainDialog(visible, row) {
      this.dialogMaintain = visible;
      if (visible) {
        this.serviceform = row;
        this.maintainTitle = this.$t("title.serviceConfirmed");
        let type = 2;
        if (
          this.DeviceInfoShow.kProduct.indexOf("微油") != -1 ||
          this.DeviceInfoShow.kProduct.indexOf("Contact Cooled") != -1
        ) {
          type = 1;
        }
        this.getMaintainItemConfirmTable(type, row.maintainRange, row.dsn);
        this.$nextTick(() => {
          this.SetMapHeight();
        });
      } else {
        this.tableCCN = new Array();
      }
    },
    async getMaintainRecord(dsn) {
      let that = this;
      let res = await getMaintainRecord(dsn);
      let data = res.result;
      that.maintainList = data;
      for (let index = 0; index < that.maintainList.length; index++) {
        const element = that.maintainList[index];
        that.maintainList[index].maintainRangeStr =
          that.maintainList[index].maintainRange +
          that.$t("title.maintainType");
        if (element.maintainType === 1) {
          that.maintainList[index].maintainTypeStr = that.$t(
            "title.alreadyMaintained"
          );
        } else {
          that.maintainList[index].maintainTypeStr =
            that.$t("title.maintainLose");
        }
      }
    },
    async getMaintainItemConfirmTable(type, runningTime, dsn) {
      let that = this;
      let res = await getMaintainItemConfirmTable(type, runningTime, dsn);
      let data = res.result;
      that.tableService = data;
    },
    async getAlarmDetail() {
      let res = await getAlarmDetailById(this.toolParam.id);
      this.$refs.deviceInfoRef.openWarningInfoDialog(true, res.result);
    },
    async toolClick() {
      let dom = document.getElementById("detail");
      dom.onclick = this.getAlarmDetail;
    },
    initTimeEcharts(echartData) {
      var Linecolor = ["#28739A", "#55B478", "#27508B", "#FFDE76", "#369089"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];
      var time_list = echartData.dateTimeList;

      let options = this.echartID.getOption();
      this.timeZoomStart = options?.dataZoom[0].start ?? 0;
      this.timeZoomEnd = options?.dataZoom[0].end ?? 100;

      let DataName = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;          
        } else {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        DataName.push(curCode);
      }

      var seriesList = [];
      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          name: echartData.codeList[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: DataName,
          textStyle: {
            color: "#828393",
            align: "left",
          },
          left: 0,
          top: 0,
          itemWidth: 16,
          itemHeight: 6,
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 150];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: (param) => {
            let str =
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" +
              param[0].axisValue +
              "</div>" +
              "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit =
                echartData.chartDataList.find(
                  (item) => item.code === element.seriesName
                )?.unit ?? "";
              str +=
                "<div style='margin: 10px 0 0;line-height:1;'>" +
                "<div style='margin: 0px 0 0;line-height:1;'>" +
                element.marker +
                "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" +
                curCode +
                "</span>" +
                "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>" +
                (element.value + "").parseNum() +
                "&nbsp" +
                unit +
                "<span>" +
                "<div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            }
            str +=
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            return str;
          },
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: this.timeZoomStart,
            end: this.timeZoomEnd,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: time_list,
          },
        ],
        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: seriesList,
      };

      this.echartID.setOption(optionK);

      window.addEventListener("resize", () => {
        this.echartID.resize();
      });
    },
    initEchartsGsn(id, echartData) {
      var Kchart1 = id;
      var startCount = 80;
      if (echartData && echartData.chartDataList.length > 0) {
        startCount = 100 - 6000 / echartData.chartDataList[0].dataList.length;
      }
      startCount < 0 ? 0 : startCount;
      startCount = 0;

      var Linecolor = ["#28739A", "#55B478", "#27508B", "#FFDE76", "#369089"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];
      var seriesList = [];
      let codeListShow = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;
        } else {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        codeListShow.push(curCode);
      }

      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          name: echartData.codeList[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: codeListShow,
          textStyle: {
            color: "#828393",
            align: "left",
          },
          left: 0,
          top: 0,
          itemWidth: 16,
          itemHeight: 6,
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 150];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: (param) => {
            let str =
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" +
              param[0].axisValue +
              "</div>" +
              "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit =
                echartData.chartDataList.find(
                  (item) => item.code === element.seriesName
                )?.unit ?? "";
              str +=
                "<div style='margin: 10px 0 0;line-height:1;'>" +
                "<div style='margin: 0px 0 0;line-height:1;'>" +
                element.marker +
                "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" +
                curCode +
                "</span>" +
                "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>" +
                (element.value + "").parseNum() +
                "&nbsp" +
                unit +
                "<span>" +
                "<div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            }
            str +=
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            return str;
          },
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: startCount,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: echartData.dateTimeList,
          },
        ],

        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: seriesList,
      };

      Kchart1.setOption(optionK, true);

      window.addEventListener("resize", () => {
        Kchart1.resize();
      });
    },
    initEchartsGsntemp(id, echartData, trapData) {
      let that = this;
      //   var trapData=[//告警的数据，1为告警未处理,2为故障未处理，3为告警 故障已处理，0 为无数据
      //   0,0,0,0,0,0,0,
      //   {info:"告警内容告警内容告警内容",status:"warning",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"},
      //   0,0,0,0,0,0,0,0,
      //   {info:"告警内容告警内容告警内容",status:"trap",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"},
      //   0,0,0,0,0,0,
      //   {info:"告警内容告警内容告警内容",status:"safe",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"},
      //   0,0,0,0,0,0,0,0,
      //   {info:"告警内容告警内容告警内容",status:"warning",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"},
      //   0,0,0,0,,0,0,
      //   {info:"告警内容告警内容告警内容",status:"safe",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"},
      //   0,0,0,0,0,0,0,0,
      //  // {info:"告警内容告警内容告警内容",status:"warning",time:"2023-11-16 12:12:32",timeEnd:"2023-11-16 12:12:32"}，
      //   0,0,0,0,0,0
      //   ];
      var trapSeriesData = [];
      var TrapColor = "";
      for (var i = 0; i < trapData.length; i++) {
        if (trapData[i]) {
          switch (trapData[i].status) {
            case 2:
              TrapColor = "green";
              trapSeriesData.push({
                value: 1,
                symbolSize: 20,
                symbol:
                  "image://data:image/png;base64,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",
              });
              break;
            default:
              if (trapData[i].alarmType == "onWarning") {
                TrapColor = "yellow";
                trapSeriesData.push({
                  value: 1,
                  symbolSize: 20,
                  symbol:
                    "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADGUlEQVRIS72WaUhUURTH/2ccl9wTRVNRE5eKoA9toCSBqERlRSs5UwTZFylCIShTSbMgUKLoSwZRarTSjug4EGZC24cgLE1MTU1RzD0d35sT7+WoM/NmXNCZT/PuPef+7v3fc+45BBs/1mlXG4n3MSGFQOEAApnhrGROhAkA3QxuJUaliukxJZV+U7S1HBzVacNcVLgMxiEAKlsbmmXcCMJ9gxFn3ZNK22ba0syPCZ1mKxE9AuC/QJClWy8z73dOKntjmpgCSjAVUSUDLosEk5chwGBkTjFBZSDrtGEi4fMinszqpAbGekleGSjoteVgHJ7tZEZmNP0eR3e/FCNAoK8zola4QkVmN6O8DOGeOrE0jaRoFAlf7QXIwKiIW1U9ePq+H72DgtmC/t5q7Nnsi+PJAfBxd7K3Z6MTYy2J1ZocBuXbsvzUNIJTJW3oGxYRGeiKxHVeiAhwlc1besah/zKE5u5x+Hk64Vp6GDZEediEEjiXBL2mFkzxSlYS7Nj1FriqCbkHg7Fzow/IQj5mxsuPA8h/0IlxgXH7ZIRtKPE7EvXaX8wItQRKMm670AiDwCjPjERsiNuUyciYKP/3cJuWsKFjDGnFzXBREyryYhTlJUI7CdWaCYDUlsCiZ10o0fXiytFQpG7yNZvWFDfL32WZkWbjLz7048yddqQn+SNrd5CCaCyQUK1lyxkpGhPONcB7mRNe50RZybij4Ifs8ion2sxVknd7QRMG/4qouRSrGL2KwMbOMaQWNiE92R9Zu6x3agso0Yued6GkqhcvsqMQEzx9DaadKQJr6odw4kYrCtNCsDduuZU09oBP6v4gu7wDNzPCkbDGy8pXEfi2fgjp9oAXJyU9by6ptLoJWJIRji1zBc4m6cPaPvmRPBDvZ3WCBUk6W9DUfR+WQXGrPOcfNKJea1AqrPbS4sjVnzLo7umV80oLqVAvQeKrUJEXbSfxHf60Ofrxdnh5km59vgW4a7IABy2kAEtAuVNzZIshQZeqiQJgYMsmypRMDm0TTVCHNsIznw3LVp+Zg5QK9X8fFoioay6t/j9aYd4OtW09PAAAAABJRU5ErkJggg==",
                });
              } else {
                TrapColor = "red";
                trapSeriesData.push({
                  value: 1,
                  symbolSize: 20,
                  symbol:
                    "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAC50lEQVRIS82WS0hUURjHf+fOjDr5GN8PTMUCQ4pAykVUIG0kEzLQiFwXtEmiNgW6KKhNIdYiqLZGoJCBBW5C0mhRMRGFJJSoie/H+GicuXPnxL16ze7cMROZOstzv3N+5/vf//nOJ4gy3p86UepwhWulFJVAEZADuKKEq8A4MCiE7NJUpf3A0+d9drHCOvmurrrQQfiWgDMSlGgH2mheQFjCEw3l6sG2zqH1sb8BvbXVFYhwG5C5FZDNmimkUlfW3tltflsDrsK6gLhtgpnbBJFKpQk1gKsyvt/GzKxnntJQDujyGkBvXVUrcPZPmUkJwwGVaTVshGa4FAriXYgIJ9ju9Lis7UW9MNzolJ82MsiiFubZxCLds37mQiswc6Q6FSrS3JzMTiLJEd1jupG0kNgnPpw+3iiluB4tu76lILcHZ5kPhcmPd1DucZMX5zDCR4Mab31+RgIaKU6FK0VplCZGt4AQskl466p6gcN2QB12/ds0LiE4l+/hSGoCwqKflJKeuWUejfhQpaRpV8ZG0Nc6cBjYaQXqMjZ8mUQNS27szqDIHe3Or6wc9Ks0fp3GpQha9mRFk/e78NZWqQicVmDr6Dwdk0tcLEjlaJobTUo+LwbZmxSHYzVL61zPrJ+7w3PUZCVSn5cSKZokpGcorV90N57vGyfRodBckmnI+HEhwI2BGQ553DQUeowlLUM+3vj8NBansz85Hl3eS/2TLGmSB6U5tu61BQ4tq1zun6ImO4n63GRjcz0bE6BD9aHDzAOYWbeOLdAxscidkkwKEyJ/gy3QuxDg5sAMF3Z6OJa+Y02A9VB90grT517O/OD+dx/XitMpS46PkPX/AMZc0l+mETSXZG27aYJ2D+tWrsWrWT/3NroWoP6Di78Npa13bpmHmy1tf1e8nZR7EizFe5mRQGjzxTvmz1PMH2AdGPMWw8hypWOLTRNlFryYtokmNKaN8PrSHtHqS3LtHmpjjSSEYGwzrf5POwz6jJZ29BUAAAAASUVORK5CYII=",
                });
              }
              break;
          }
        } else {
          trapSeriesData.push({
            value: 1,
            symbolSize: 0,
          });
        }
      }

      var Kchart1 = id;
      var startCount = 80;
      if (echartData) {
        startCount = 100 - 6000 / echartData.chartDataList[0].dataList.length;
      }
      startCount < 0 ? 0 : startCount;

      var Linecolor = ["#28739A", "#55B478", "#27508B", "#FFDE76", "#369089"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];
      var seriesList = [];

      let codeListShow = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;
        } else {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        codeListShow.push(curCode);
      }

      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          xAxisIndex: 0,
          yAxisIndex: 0,
          name: echartData.codeList[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }
      var TripLine = {
        xAxisIndex: 1,
        yAxisIndex: 1,
        type: "line",
        data: trapSeriesData,
        lineStyle: {
          color: "#696D6F",
          width: 2,
        },
        tooltip: {
          trigger: "item",
          enterable: true,
          renderMode: "html",
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] - 50, point[1] + 10];
          },
          formatter: (param) => {
            that.toolParam = trapData[param.dataIndex];
            that.toolNumber++;
            var pic = "";
            switch (trapData[param.dataIndex].status) {
              case 2:
                pic =
                  "data:image/png;base64,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";
                break;
              default:
                if (trapData[param.dataIndex].alarmType == "onWarning") {
                  pic =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADGUlEQVRIS72WaUhUURTH/2ccl9wTRVNRE5eKoA9toCSBqERlRSs5UwTZFylCIShTSbMgUKLoSwZRarTSjug4EGZC24cgLE1MTU1RzD0d35sT7+WoM/NmXNCZT/PuPef+7v3fc+45BBs/1mlXG4n3MSGFQOEAApnhrGROhAkA3QxuJUaliukxJZV+U7S1HBzVacNcVLgMxiEAKlsbmmXcCMJ9gxFn3ZNK22ba0syPCZ1mKxE9AuC/QJClWy8z73dOKntjmpgCSjAVUSUDLosEk5chwGBkTjFBZSDrtGEi4fMinszqpAbGekleGSjoteVgHJ7tZEZmNP0eR3e/FCNAoK8zola4QkVmN6O8DOGeOrE0jaRoFAlf7QXIwKiIW1U9ePq+H72DgtmC/t5q7Nnsi+PJAfBxd7K3Z6MTYy2J1ZocBuXbsvzUNIJTJW3oGxYRGeiKxHVeiAhwlc1besah/zKE5u5x+Hk64Vp6GDZEediEEjiXBL2mFkzxSlYS7Nj1FriqCbkHg7Fzow/IQj5mxsuPA8h/0IlxgXH7ZIRtKPE7EvXaX8wItQRKMm670AiDwCjPjERsiNuUyciYKP/3cJuWsKFjDGnFzXBREyryYhTlJUI7CdWaCYDUlsCiZ10o0fXiytFQpG7yNZvWFDfL32WZkWbjLz7048yddqQn+SNrd5CCaCyQUK1lyxkpGhPONcB7mRNe50RZybij4Ifs8ion2sxVknd7QRMG/4qouRSrGL2KwMbOMaQWNiE92R9Zu6x3agso0Yued6GkqhcvsqMQEzx9DaadKQJr6odw4kYrCtNCsDduuZU09oBP6v4gu7wDNzPCkbDGy8pXEfi2fgjp9oAXJyU9by6ptLoJWJIRji1zBc4m6cPaPvmRPBDvZ3WCBUk6W9DUfR+WQXGrPOcfNKJea1AqrPbS4sjVnzLo7umV80oLqVAvQeKrUJEXbSfxHf60Ofrxdnh5km59vgW4a7IABy2kAEtAuVNzZIshQZeqiQJgYMsmypRMDm0TTVCHNsIznw3LVp+Zg5QK9X8fFoioay6t/j9aYd4OtW09PAAAAABJRU5ErkJggg==";
                } else {
                  pic =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAC50lEQVRIS82WS0hUURjHf+fOjDr5GN8PTMUCQ4pAykVUIG0kEzLQiFwXtEmiNgW6KKhNIdYiqLZGoJCBBW5C0mhRMRGFJJSoie/H+GicuXPnxL16ze7cMROZOstzv3N+5/vf//nOJ4gy3p86UepwhWulFJVAEZADuKKEq8A4MCiE7NJUpf3A0+d9drHCOvmurrrQQfiWgDMSlGgH2mheQFjCEw3l6sG2zqH1sb8BvbXVFYhwG5C5FZDNmimkUlfW3tltflsDrsK6gLhtgpnbBJFKpQk1gKsyvt/GzKxnntJQDujyGkBvXVUrcPZPmUkJwwGVaTVshGa4FAriXYgIJ9ju9Lis7UW9MNzolJ82MsiiFubZxCLds37mQiswc6Q6FSrS3JzMTiLJEd1jupG0kNgnPpw+3iiluB4tu76lILcHZ5kPhcmPd1DucZMX5zDCR4Mab31+RgIaKU6FK0VplCZGt4AQskl466p6gcN2QB12/ds0LiE4l+/hSGoCwqKflJKeuWUejfhQpaRpV8ZG0Nc6cBjYaQXqMjZ8mUQNS27szqDIHe3Or6wc9Ks0fp3GpQha9mRFk/e78NZWqQicVmDr6Dwdk0tcLEjlaJobTUo+LwbZmxSHYzVL61zPrJ+7w3PUZCVSn5cSKZokpGcorV90N57vGyfRodBckmnI+HEhwI2BGQ553DQUeowlLUM+3vj8NBansz85Hl3eS/2TLGmSB6U5tu61BQ4tq1zun6ImO4n63GRjcz0bE6BD9aHDzAOYWbeOLdAxscidkkwKEyJ/gy3QuxDg5sAMF3Z6OJa+Y02A9VB90grT517O/OD+dx/XitMpS46PkPX/AMZc0l+mETSXZG27aYJ2D+tWrsWrWT/3NroWoP6Di78Npa13bpmHmy1tf1e8nZR7EizFe5mRQGjzxTvmz1PMH2AdGPMWw8hypWOLTRNlFryYtokmNKaN8PrSHtHqS3LtHmpjjSSEYGwzrf5POwz6jJZ29BUAAAAASUVORK5CYII=";
                }
                break;
            }

            let str = "<div style='margin: 0px 0 0;line-height:1;'>";
            str +=
              "<div style = 'font-size:12px;color:#fff;font-weight:400;margin-left:2px;line-height:21px;margin-bottom:5px;'><img style='width:20px;height:20px;vertical-align: text-bottom;' src=" +
              pic +
              " />" +
              that.$t("desc." + trapData[param.dataIndex].alarmType) +
              that.$t("desc.codeAlarm") +
              " " +
              trapData[param.dataIndex].alarmCode +
              that.$t("desc.rightkuohao") +
              "</div>" +
              "<div style = 'font-size:11px;color:#828393;font-weight:400;line-height:14px;margin-bottom:5px;' >" +
              that.$t("title.alarmContent") +
              ": " +
              trapData[param.dataIndex].alarmContent +
              "</div>" +
              "<div style = 'font-size:11px;color:#828393;font-weight:400;line-height:14px;margin-bottom:5px;' >" +
              that.$t("title.alarmSta") +
              ": " +
              (trapData[param.dataIndex].status == 2
                ? that.$t("title.relieve")
                : that.$t("title.error")) +
              "</div>" +
              "<div style = 'font-size:11px;color:#828393;font-weight:400;line-height:14px;margin-bottom:5px;' >" +
              that.$t("title.alarmTime") +
              ": " +
              trapData[param.dataIndex].alarmTime +
              "</div>" +
              "<div style = 'font-size:11px;color:#828393;font-weight:400;line-height:14px;margin-bottom:5px;' >" +
              that.$t("title.relieveTime") +
              ": " +
              trapData[param.dataIndex].relieveTime +
              "</div>" +
              "<a id='detail' style = 'text-decoration: underline;margin-bottom:5px;font-size:11px;color:#828393;font-weight:400;line-height:14px;width:100%;display:block;text-align:right;cursor:pointer;'>点击查看详情&gt;&gt;</a>";

            str += "<div style='clear:both'></div>";
            return str;
          },
        },
      };
      seriesList.push(TripLine);

      var optionK = {
        legend: {
          data: codeListShow,
          textStyle: {
            color: "#828393",
            align: "left",
          },
          left: 0,
          top: 0,
          itemWidth: 16,
          itemHeight: 6,
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          hideDaley: 200,
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] + 10];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: (param) => {
            let str =
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='margin: 0px 0 0;line-height:1;'>" +
              "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" +
              param[0].axisValue +
              "</div>" +
              "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit =
                echartData.chartDataList.find(
                  (item) => item.code === element.seriesName
                )?.unit ?? "";
              str +=
                "<div style='margin: 10px 0 0;line-height:1;'>" +
                "<div style='margin: 0px 0 0;line-height:1;'>" +
                element.marker +
                "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" +
                curCode +
                "</span>" +
                "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>" +
                (element.value + "").parseNum() +
                "&nbsp" +
                unit +
                "<span>" +
                "<div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            }
            str +=
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>";
            return str;
          },
        },
        grid: [
          {
            top: 60,
            left: 40,
            right: 40,
            bottom: 80,
          },
          {
            top: 30,
            left: 40,
            right: 40,
            bottom: 80,
          },
        ],
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0, 1],
            bottom: 20,
            start: 0,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            gridIndex: 0,
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: echartData.dateTimeList,
          },
          {
            gridIndex: 1,
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: echartData.dateTimeList,
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: "value",
            splitNumber: 3,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          {
            gridIndex: 1,
            type: "value",
            splitNumber: 1,
            min: 0,
            max: 1,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
        ],
        series: seriesList,
      };

      Kchart1.setOption(optionK, true);

      window.addEventListener("resize", () => {
        Kchart1.resize();
      });
    },
    InitURateLine(data) {
      var that = this;
      var URateLine = this.$echarts.init(document.getElementById("URateLine"));
      var dataLine = data.dayDataList;
      // var timeLine = [
      //   //最近12个月
      //   this.$t("el.datepicker.months.jan"),
      //   this.$t("el.datepicker.months.feb"),
      //   this.$t("el.datepicker.months.mar"),
      //   this.$t("el.datepicker.months.apr"),
      //   this.$t("el.datepicker.months.may"),
      //   this.$t("el.datepicker.months.jun"),
      //   this.$t("el.datepicker.months.jul"),
      //   this.$t("el.datepicker.months.aug"),
      //   this.$t("el.datepicker.months.sep"),
      //   this.$t("el.datepicker.months.oct"),
      //   this.$t("el.datepicker.months.nov"),
      //   this.$t("el.datepicker.months.dec"),
      // ];
      var timeLine = data.dayTimeList;
      var optionURateLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            // return [point[0] / 2 - 80, point[1] - 80];
            return [point[0] / 2 - 50, size.viewSize[1] - 20]; // 固定在底部，距离底部20px
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: "{b}<br />{a}<br />{c}% ",
        },
        grid: {
          top: 5,
          left: 28,
          right: 5,
          bottom: 5,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: {
          name: that.$t("desc.UtilizationRate"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: false,
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            normal: {
              color: "rgba(255,255,255,1)",
            },
          },
          itemStyle: {
            // color: "rgba(58,64,73,1)",
            borderColor: "rgba(255,255,255,1)",
            borderWidth: 1,
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255,255,255,0.5)" },
                { offset: 0.9, color: "rgba(255,255,255,0)" },
                { offset: 1, color: "rgba(255,255,255,0)" },
              ]),
            },
          },
          data: dataLine,
          cursor: "default",
        },
      };
      URateLine.setOption(optionURateLine);

      window.addEventListener("resize", () => {
        URateLine.resize();
      });
    },
    InitLoadedChangeLine(data) {
      var that = this;
      var LoadedChangeLine = this.$echarts.init(document.getElementById("LoadedChangeLine"));
      var dataLine = data.map(element => {
        return element.uploadUnLoadChangeCount;
      });
      var timeLine = data.map(element => {
        return element.cycle;
      });
      var optionLoadedChangeLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            // return [point[0] / 2 - 80, point[1] - 80];
            return [point[0] / 2 - 50, size.viewSize[1] - 20]; // 固定在底部，距离底部20px
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: "{b}<br />{a}: {c} ",
        },
        grid: {
          top: 5,
          left: 28,
          right: 5,
          bottom: 5,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            }
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: {
          name: that.$t("desc.times"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: false,
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            normal: {
              color: "rgba(255,255,255,1)",
            },
          },
          itemStyle: {
            // color: "rgba(58,64,73,1)",
            borderColor: "rgba(255,255,255,1)",
            borderWidth: 1,
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255,255,255,0.5)" },
                { offset: 0.9, color: "rgba(255,255,255,0)" },
                { offset: 1, color: "rgba(255,255,255,0)" },
              ]),
            },
          },
          data: dataLine,
          cursor: "default",
        },
      };
      LoadedChangeLine.setOption(optionLoadedChangeLine);

      window.addEventListener("resize", () => {
        LoadedChangeLine.resize();
      });
    },
    SetMapHeight() {
      this.TableH = window.innerHeight * 0.8 - 190 + "px";
    },
  },
};
